import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function DealTypeAPi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealType`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllDeal() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealsByReportingUsers`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllDealPagination(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealsByReportingUsers?page=${page}&limit=${limit}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllDealSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealsByReportingUsers?search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllDealPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealsByReportingUsers?page=${page}&limit=${limit}&search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function PriorityDealApi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllPriority`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function HoldReasonapi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealHoldReason`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LostReasonApi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealLostReason`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function wonReasonApi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllDealWonReason`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllPipeline() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllPipelineStage`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchDealDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByDealsId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchDealByAccount(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllActiveDealByAccount/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchDealByContact(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllDealsByContact/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function DealUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateDeals/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function DealScoreData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchDealScoreByDealId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massUpdateDeal(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/massUpdateDeal`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massDeleteDeals(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/massDeleteDeals`, { headers, data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createDeals(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createDeals`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    massUpdateDeal,
    massDeleteDeals,
    DealTypeAPi,
    wonReasonApi,
    LostReasonApi,
    HoldReasonapi,
    PriorityDealApi,
    FetchAllDeal,
    FetchAllPipeline,
    FetchDealDetails,
    FetchDealByContact,
    FetchDealByAccount,
    DealUpdate,
    DealScoreData,
    AllDealPagination,
    AllDealPaginationSearch,
    FetchAllDealSearch,
    createDeals,
}